import React from "react";


export default function Footer() {
    return (
        <footer className="footer">
            <p>© {new Date().getFullYear()} RO Service Patna. All rights reserved.</p>
        </footer>
    );
}